import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class BuyService {

  constructor(private http: HttpClient) {}

   getBuyData(userSession: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    return this.http.get(
      `${ApiConfig.baseUrl}/Buy/get-buy-data`,
      { headers }
    );
  }
  getProductCategoryData(
        userSession: string,
        mainCategoryId: string,
        subCategoryId: string,
        productTypeId: string,
        productDurationId: string,
        beneficiaryId: string,
        requestType: string
        ): Observable<any> {

        const headers = new HttpHeaders({
            'X-Api-Key': ApiConfig.apiKey,
            'Authorization': `Bearer ${userSession}`
        });

        const params = {
            mainCategoryId,
            subCategoryId,
            productTypeId,
            productDurationId,
            beneficiaryId,
            requestType
        };

        return this.http.get(
            `${ApiConfig.baseUrl}/ProductCategory/get-product-category-data`,
            {
            headers,
            params,
            observe: 'response'
            }
        );
    }
    postBuy(userSession: string, 
          authorizationPin: string, 
          beneficiaryId: string,
          newBeneficiaryName: string,
          newBeneficiaryNumber: string,
          newBeneficiaryDisplayNumber: string,
          productId: string,
          electricityMeterId: string,
          meterName: string,
          meterNumber: string,
          amount: number
        ): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      authorizationPin,
      beneficiaryId,
      newBeneficiaryName,
      newBeneficiaryNumber,
      newBeneficiaryDisplayNumber,
      productId,
      electricityMeterId,
      meterName,
      meterNumber,
      amount
    };
    return this.http.post(
    `${ApiConfig.baseUrl}/buy/buy`,
    request,
    {
        headers,
        observe: 'response'
    }
    );
  }
   postPayForMe(userSession: string, 
          productId: string,
          payerId: string,
          newPayerName: string,
          newPayerNumber: string,
          newPayerDisplayNumber: string,
          electricityMeterId: string,
          meterName: string,
          meterNumber: string,
          amount: number
        ): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      productId,
      payerId,
      newPayerName,
      newPayerNumber,
      newPayerDisplayNumber,
      electricityMeterId,
      meterName,
      meterNumber,
      amount
    };
    return this.http.post(
    `${ApiConfig.baseUrl}/buy/pay-for-me`,
    request,
    {
        headers,
        observe: 'response'
    }
    );
  }
}